export { CameraIcon } from "./camera";
